import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { CommonConstants } from '../constants/common.constant';

@Injectable({
  providedIn: 'root',
})
export class RecordsPerPageFilterService {
  public recordsPerPage = new Subject<number>();
  public resetRecordsPerPage(): void {
    this.recordsPerPage.next(CommonConstants.recordsPerPageOptions[0]);
  }
}
